var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AgentPermissionsModal',{attrs:{"apps-loading":_vm.isLoading,"is-processing":_vm.isProcessing,"email":_vm.agent.email,"permissions":_vm.permissions,"value":_vm.value},on:{"update:permissions":function($event){_vm.permissions=$event},"close":_vm.close,"closed":_vm.updatePermissionsToTransformed,"submit":_vm.updatePermissions}})
}
var staticRenderFns = []

export { render, staticRenderFns }